module.exports = __webpack_public_path__ + "static/favicon-e7383f0c09131a1da757e57843111a1a.ico";